import { persistedEnumAtom } from '@/core/state';
import { StorageKey } from '@/core/storage';
import { defaultUnitSystem, UNIT_SYSTEM_IDS } from './unitSystems';

export const unitsAtom = persistedEnumAtom(StorageKey.Units, UNIT_SYSTEM_IDS, defaultUnitSystem());
